import React, {Component} from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
//import Badge from '@material-ui/core/Badge';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
//import NotificationsIcon from '@material-ui/icons/Notifications';
import InfoSummaryListItem from './ListItems/InfoSummayListItem';
import EventManagementListItem from './ListItems/EventManagementListItem';
import RecordManagementListItem from './ListItems/RecordManagementListItem';
import StaticPageManagementListItem from './ListItems/StaticPageManagementListItem'
import QAManagementListItem from './ListItems/QAManagementListItem';
import TrafficManagementListItem from './ListItems/TrafficManagementListItem';
import InfoSummaryBody from './Routes/InfoSummaryBody';
import RecordManagementBody from './Routes/RecordManagementBody';
import EventManagementBody from './Routes/EventManagementBody';
import StaticPageManagementBody from './Routes/StaticPageManagementBody'
import QAManagementBody from './Routes/QAManagementBody';
import TrafficManagementBody from './Routes/TrafficManagementBody';
//import EventEditBody from './Routes/EventEdit/EventEditBody';
import EventCreateBody from './Routes/EventCreate/EventCreateBody';
import StaticPageCreateBody from './Routes/StaticPage/StaticPageCreate/StaticPageCreateBody';
import {BrowserRouter, Route} from 'react-router-dom';
import {Switch} from 'react-router';
import webSocket from 'socket.io-client'
import ChatRoom from './ChatRoom/ChatRoom'
import ChatChannel from './ChatRoom/ChatChannel'
import ScreenshotContainer from './Screenshot/ScreenshotContainer'
import html2canvas from 'html2canvas'
import {server_ip} from '../ipAddress'


const drawerWidth = 240;
  
const wStyles = theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
    fontFamily:'Microsoft JhengHei',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
});

// all page infos would be stored in this component !
class MainBodyTest extends Component {
    constructor(props) {
        super(props)
        this.state = {
          open:true,
          currentModule:null,
          wsMiddleWare:null,
          allUsers:null,
          currentUsers:null,
          allChat:null,
          chatChannelList:null,
          allChannelList:null,
          toggleScreenshotPicker:false,
          screenshotArea:null,
          screenshotEmitInfo:null,
          currentVisitors:null,
          allQuery:null
        }
    }

    componentDidMount(){
        this.initialWSMiddleWare()
        window.addEventListener("beforeunload",(e)=>this.userSessionEnd(e))
        window.addEventListener("unload",(e)=>this.emitUserSessionEnd(e))
        this.getAllUsers()
    }

    componentDidUpdate(prevProps,prevState){
      if(this.state.screenshotArea)
      {
        let msg = this.state.screenshotArea
        this.captureScreenShot(msg.x, msg.y, msg.width, msg.height, this.state.screenshotEmitInfo)
        this.setState({
          screenshotArea:null,
          screenshotEmitInfo:null
        })
      }
        //console.log("componentDidUpdate")
        //this.dealWebSocket()    
    }

    componentWillUnmount(){
      window.removeEventListener("beforeunload", this.userSessionEnd)
      window.removeEventListener("unload",this.emitUserSessionEnd)
    }

    captureScreenShot=(posX,posY,width,height, emitInfo)=>{
      html2canvas(document.body,{
        useCORS:true,
        allowTaint:false
      }).then((canvas)=>{
        let tempCanvas = document.createElement('canvas')
        let tempCanvasContext = tempCanvas.getContext('2d')
        
        tempCanvas.width = width/9*10
        tempCanvas.height = height/9*10
        tempCanvasContext.drawImage(canvas, posX/9*10, posY/9*10, width/9*10, height/9*10, 0, 0, width/9*10, height/9*10)
       
        //var a = document.createElement('a')
        var screenshotImg = tempCanvas.toDataURL("image/jpeg")
        //a.download = 'testScreenShot.jpg'
        //a.click()
        let tempObj = {}
        tempObj[this.props.userID] = true
        
        if(emitInfo.type === "chat")
        {
          this.state.wsMiddleWare.emit('image',{channelID:emitInfo.channelID, emitID:this.props.userID, emitName:this.props.userName, targetID:emitInfo.userID, emitImage:screenshotImg, read:tempObj})
        }
        else if(emitInfo.type === "query")
        {
          this.state.wsMiddleWare.emit('query_image',{channelID:emitInfo.channelID, emitID:this.props.userID, emitName:this.props.userName, targetID:emitInfo.userID, emitImage:screenshotImg, read:tempObj})
        }
        
      })
    }

    initialWSMiddleWare=()=>{
      this.setState({
        wsMiddleWare:webSocket(server_ip)
      },()=>{
        this.createPersonalRoom()
        this.dealWebSocket()
      })
    }

    userSessionEnd=(e)=>{
      e.preventDefault()           
      e.returnValue = ""  
    }

    getAllUsers=async()=>{
      let msg = await fetch(server_ip+'/frontEnd/userBehavior/allusers')

      let output = await msg.json()
      if(msg.status !== 200) throw Error(msg.message)
      console.log("getAllUsers")
      console.log(output)
      this.setState({
        allUsers:output
      })
    }

    emitUserSessionEnd=(e)=>{ 
      e.preventDefault()     
      this.state.wsMiddleWare.emit('user_logout',{userID:this.props.userID, userName:this.props.userName})
      //e.returnValue = ""
    }

    createPersonalRoom=()=>{
      if(this.props.userID)
      {
        this.state.wsMiddleWare.emit('user_login',{userID:this.props.userID, userName:this.props.userName})
      }
    }

    countUnreadMesage=()=>{
      let resultArray = []
      if(this.state.allChat)
      {
        let tempArray = Object.keys(this.state.allChat)
        //console.log("countUnreadMesage")
        //console.log(tempArray)
        tempArray.forEach(channel=>{
          console.log("countUnreadMesage")
          console.log(channel)
          if(this.state.allChat[channel])
          {
            this.state.allChat[channel].forEach(chat=>{
              if(!chat.read[this.props.userID])
              {
                resultArray.push(chat)
              }
            })
          }          
        })

        return resultArray
      }
      else
      {
        return resultArray
      }
    }

    countUnreadQuery=()=>{
      let resultArray = []
      if(this.state.allQuery)
      {
        let tempArray = Object.keys(this.state.allQuery)
        //console.log("countUnreadMesage")
        //console.log(tempArray)
        tempArray.forEach(channel=>{
          console.log("countUnreadQuery")
          console.log(channel)
          if(this.state.allQuery[channel])
          {
            this.state.allQuery[channel].forEach(query=>{
              if(query.read && !query.read[this.props.userID])
              {
                resultArray.push(query)
              }
            })
          }          
        })

        return resultArray
      }
      else
      {
        return resultArray
      }
    }

    createChatChannel=()=>{
      if(this.state.allChannelList)
      {
        let channelList = Object.keys(this.state.allChannelList)
        let output = channelList.map((channel,index)=>{
          
          let tempMessage

          if(this.state.allChannelList[channel].type === "chat")
          {
            if(this.state.allChat && this.state.allChat[channel])
            {
              tempMessage = this.state.allChat[channel]
            }
            else
            {
              tempMessage = null
            }
          }
          else if(this.state.allChannelList[channel].type === "query")
          {
            if(this.state.allQuery && this.state.allQuery[channel])
            {
              tempMessage = this.state.allQuery[channel]
            }
            else
            {
              tempMessage = null
            }
          }
          
          
          return <ChatChannel key={index} index={index} hostUserID={this.props.userID} channelInfo={this.state.allChannelList[channel]} visitorOnline={this.state.currentVisitors[this.state.allChannelList[channel].visitorID]? true : false } textInfo={tempMessage} closeChannel={this.closeChannel} getChatMessage={this.getChatMessage} getQueryMessage={this.getQueryMessage} takeScreenShot={this.takeScreenShot} markRead={this.markRead}/>
        })
        return output
      }
      else
      {
        return null
      }
    }

    dealWebSocket=()=>{
      this.state.wsMiddleWare.on('user_login', data =>{
          //console.log(data)
        this.updateUserStatus(data)
      })

      this.state.wsMiddleWare.on('user_logout', data=>{
        this.updateUserStatus(data)
      })

      this.state.wsMiddleWare.on('visitor_visit', data =>{
        console.log(data)
        this.updateVisitorStatus(data)
      
      })

      this.state.wsMiddleWare.on('visitor_leave', data =>{
        console.log(data)
        this.updateVisitorStatus(data)
      })

      this.state.wsMiddleWare.on('chat', data=>{
        console.log("socket on chat")
        //console.log(data)
        let tempState = {}

        
        if(this.state.allChat && this.state.allChat[data[0].channelID])
        {
          if(data !== this.state.allChat[data[0].channelID])
          {            
            tempState = this.state.allChat
            tempState[data[0].channelID] = data
            this.setState({
              allChat:tempState
            })
          } 
        }
        else
        {
          if(this.state.allChat)
          {
            tempState = this.state.allChat
            tempState[data[0].channelID] = data
            this.setState({
              allChat:tempState
            })
          }
          else
          {
            tempState[data[0].channelID] = data
            this.setState({
              allChat:tempState
            })
          }
        }
      })

      this.state.wsMiddleWare.on('image', data=>{
        //console.log("socket on image")
        //console.log(data)
        let tempState = {}

        if(this.state.allChat && this.state.allChat[data[0].channelID])
        {
          if(data !== this.state.allChat[data[0].channelID])
          {            
            tempState = this.state.allChat
            tempState[data[0].channelID] = data
            this.setState({
              allChat:tempState
            })
          } 
        }
        else
        {
          if(this.state.allChat)
          {
            tempState = this.state.allChat
            tempState[data[0].channelID] = data
            this.setState({
              allChat:tempState
            })
          }
          else
          {
            tempState[data[0].channelID] = data
            this.setState({
              allChat:tempState
            })
          }
        }
      })

      this.state.wsMiddleWare.on('query_image', data=>{
        //console.log("socket on image")
        //console.log(data)
        let tempState = {}

        if(this.state.allQuery && this.state.allQuery[data[0].channelID])
        {
          if(data !== this.state.allQuery[data[0].channelID])
          {            
            tempState = this.state.allQuery
            tempState[data[0].channelID] = data
            this.setState({
              allQuery:tempState
            })
          } 
        }
        else
        {
          if(this.state.allQuery)
          {
            tempState = this.state.allQuery
            tempState[data[0].channelID] = data
            this.setState({
              allQuery:tempState
            })
          }
          else
          {
            tempState[data[0].channelID] = data
            this.setState({
              allQuery:tempState
            })
          }
        }
      })

      this.state.wsMiddleWare.on('query', data=>{
        console.log('socket on query')
        //console.log(data)
        let tempState = {}

        if(data && data[0])
        {
          if(this.state.allQuery && this.state.allQuery[data[0].channelID])
          {
            if(data !== this.state.allQuery[data[0].channelID])
            {            
              tempState = this.state.allQuery
              tempState[data[0].channelID] = data
              this.setState({
                allQuery:tempState
              })
            } 
          }
          else
          {  
            if(this.state.allQuery)
            {
              tempState = this.state.allQuery
              tempState[data[0].channelID] = data
              this.setState({
                allQuery:tempState
              })
            }
            else
            {
              tempState[data[0].channelID] = data
              this.setState({
                allQuery:tempState
              })
            }
          } 
        }
      })
    }

    updateUserStatus=(data)=>{
      //console.log("updateUserStatus...")
      delete data[this.props.userID]
      this.setState({
        currentUsers:data
      })
    }

    updateVisitorStatus=(data)=>{
      if(data !== this.state.currentVisitors)
      {
        this.setState({
          currentVisitors:data
        })
      }
    }

    handleDrawerOpen=()=>{
        this.setState({
            open:true
        })
    }

    handleDrawerClose=()=>{
        this.setState({
            open:false
        })
    }

    getCurrentModule=(msg)=>{
      if(this.state.currentModule !== msg)
      {
        this.setState({
          currentModule:msg
        })
      }
    }

    getChatChannel=(user)=>{
      console.log(user)
      let channelID = this.combineChannelID(user.userID,this.props.userID)
      let tempObj = {}
      
      if(this.state.allChannelList)
      {
        let channelList = Object.keys(this.state.allChannelList)
        channelList.forEach(channel => {
          if(this.state.allChannelList[channel].channelID !== channelID)
          {
            tempObj[channel] = this.state.allChannelList[channel]
          }
        });
      }    

      let channelInfo = {
        channelID:channelID,
        userID:user.userID,
        userName:user.userName,
        type:"chat"
      }

      tempObj[channelID]= channelInfo
      
      if(this.state.allChannelList !== tempObj)
      {
        this.setState({
          allChannelList:tempObj
        },()=>{
          this.state.wsMiddleWare.emit('open_channel',{channelID:channelID, emitID:this.props.userID, targetID:user.userID, type:"chat"})
        })
      }
    }

    getQueryChannel=(visitor)=>{
      console.log("getQueryChannel")
      console.log(visitor)
      let channelID = visitor.visitorID
      let tempObj = {}
      
      if(this.state.allChannelList)
      {
        let channelList = Object.keys(this.state.allChannelList)
        channelList.forEach(channel => {
          if(this.state.allChannelList[channel].channelID !== channelID)
          {
            tempObj[channel] = this.state.allChannelList[channel]
          }
        });
      }    

      let channelInfo = {
        channelID:channelID,
        visitorID:visitor.visitorID,
        visitorName:visitor.visitorName,
        visitorIP:visitor.visitorIP,
        type:"query"
      }

      tempObj[channelID] = channelInfo
      
      if(this.state.allChannelList !== tempObj)
      {
        this.setState({
          allChannelList:tempObj
        },()=>{
          this.state.wsMiddleWare.emit('open_channel',{channelID:channelID, emitID:this.props.userID, targetID:visitor.visitorID, type:"query"})
        })
      }
    }

    markRead=(msg)=>{
      if(msg.type === "query")
      {
        if(this.state.currentVisitors[msg.channelID])
        {
          this.state.wsMiddleWare.emit('mark_read',{channelID:msg.channelID, emitID:this.props.userID, type:msg.type})
        }
        else
        {
          let tempArray = this.state.allQuery[msg.channelID].map(query=>{
            let tempObj = query.read
            tempObj[this.props.userID] = true
            let output = {
              channelID:query.channelID,
              emitDate:query.emitDate,
              emitID:query.emitID,
              emitIP:query.emitIP,
              emitImage:query.emitImage,
              emitMessage:query.emitMessage,
              emitName:query.emitName,
              emitTime:query.emitTime,
              read:tempObj
            }
            return output
          })

          let tempState = this.state.allQuery
          tempState[msg.channelID] = tempArray
          this.setState({
            allQuery:tempState
          })   
        }
      }
      else if(msg.type === "chat")
      {
        this.state.wsMiddleWare.emit('mark_read',{channelID:msg.channelID, emitID:this.props.userID, type:msg.type})
      }
    }

    getChatMessage=(msg)=>{
      let channelID = this.combineChannelID(msg.userID,this.props.userID)
      let tempObj = {}
      tempObj[this.props.userID] = true
      this.state.wsMiddleWare.emit('chat',{channelID:channelID, emitID:this.props.userID, emitName:this.props.userName, targetID:msg.userID, emitMessage:msg.emitMessage, read:tempObj})
    }

    getQueryMessage=(msg)=>{
      let tempObj = {}
      tempObj[this.props.userID] = true
      this.state.wsMiddleWare.emit('query',{channelID:msg.visitorID, emitID:this.props.userID, emitName:this.props.userName, emitIP:this.props.userIP, emitMessage:msg.emitMessage, read:tempObj})
    }

    getModuleText=()=>{
      switch(this.state.currentModule){
        case "InfoSummary":
          return "資訊縱覽"
        case "EventManagement":
          return "專題設定管理"
        case "RecordManagement":
          return "後端資料匯入管理"
        case "StaticPageManagement":
          return "靜態頁面管理"
        case "QAManagement":
          return "問題回報管理"
        case "TrafficManagement":
          return "流量資訊管理"
        default:
          return null
      }
    }

    combineChannelID=(firstID,secondID)=>{
      let output =""
      if(firstID < secondID)
      {
        output = firstID+"WITH"+secondID
      }
      else if(firstID >= secondID)
      {
        output = secondID+"WITH"+firstID
      }

      return output
    }

    closeChannel=(msg)=>{
      console.log("closeChannel")
      console.log("ID : ", msg.ID)

      if(msg.type === "chat")
      {
        let tempArray = {}
        let channelID = this.combineChannelID(msg.ID,this.props.userID)
        let channelList = Object.keys(this.state.allChannelList)
        channelList.forEach(channel=>{    
          if(this.state.allChannelList[channel].userID !== msg.ID)
          {
            tempArray[channel] = this.state.allChannelList[channel]
          }    
        })
        console.log(tempArray)
        this.setState({
          allChannelList:tempArray
        },()=>{
          this.state.wsMiddleWare.emit('close_channel',{channelID:channelID, emitID:this.props.userID, targetID:msg.ID})
        })
      }
      else if(msg.type === "query")
      {
        let tempArray = {}
        let channelList = Object.keys(this.state.allChannelList)
        channelList.forEach(channel=>{    
          if(this.state.allChannelList[channel].visitorID !== msg.ID)
          {
            tempArray[channel] = this.state.allChannelList[channel]
          }    
        })
        console.log(tempArray)
        this.setState({
          allChannelList:tempArray
        },()=>{
          this.state.wsMiddleWare.emit('close_channel',{channelID:msg.ID, emitID:this.props.userID, targetID:msg.ID})
        })
      }
    }

    takeScreenShot=(msg)=>{
      this.setState({      
        toggleScreenshotPicker:true,
        screenshotEmitInfo:msg
      })
    }

    closeScreenshotPicker=()=>{
      this.setState({
        toggleScreenshotPicker:false,
        screenshotEmitInfo:null
      })
    }

    getSreenshotArea=(msg)=>{
      this.setState({
        toggleScreenshotPicker:false,
        screenshotArea:msg
      })
    }

    render(){
        const {classes} = this.props;
       

        return(
            <BrowserRouter>
            
            <div className={classes.root}>
              {this.createChatChannel()}
             
              <CssBaseline />
              <AppBar position="absolute" className={clsx(classes.appBar, this.state.open && classes.appBarShift)}>
                <Toolbar className={classes.toolbar}>
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="open drawer"
                    onClick={this.handleDrawerOpen}
                    className={clsx(classes.menuButton, this.state.open && classes.menuButtonHidden)}
                  >
                    <MenuIcon />
                  </IconButton>
                  <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                    華語電影資料庫 管理模組 \ <span style={{color:"#ffe736"}}>{this.getModuleText()}</span>
                  </Typography>
                  {
                    // <IconButton color="inherit">
                    //   <Badge badgeContent={4} color="secondary">
                    //     <NotificationsIcon />
                    //   </Badge>
                    // </IconButton>
                  }
                </Toolbar>
              </AppBar>
              <Drawer
                variant="permanent"
                classes={{
                  paper: clsx(classes.drawerPaper, !this.state.open && classes.drawerPaperClose),
                }}
                open={this.state.open}
              >
                <div className={classes.toolbarIcon}>
                  <IconButton onClick={this.handleDrawerClose}>
                    <ChevronLeftIcon />
                  </IconButton>
                </div>
                <Divider />
                <List>
                  <InfoSummaryListItem />
                  <EventManagementListItem />
                  <RecordManagementListItem />
                  <StaticPageManagementListItem />
                  <QAManagementListItem />
                  <TrafficManagementListItem />
                </List>
                <Divider />
                <ChatRoom unreadMessage={this.countUnreadMesage()} unreadQuery={this.countUnreadQuery()} userID={this.props.userID} currentUsers={this.state.currentUsers} allUsers={this.state.allUsers} currentVisitors={this.state.currentVisitors} getChatChannel={this.getChatChannel} getQueryChannel={this.getQueryChannel}/>
                
              </Drawer>
              <Switch>
                <Route path="/dashboard" render={props=>(<RecordManagementBody {...props} userID={this.props.userID} getCurrentModule={this.getCurrentModule}/>)} />
                <Route path="/InfoSummary/Default" render={props=>(<InfoSummaryBody {...props} userID={this.props.userID} getCurrentModule={this.getCurrentModule}/>)} />
                <Route path="/EventManagement/Default" render={props=>(<EventManagementBody {...props} userID={this.props.userID} getCurrentModule={this.getCurrentModule}/>)} />
                <Route path="/RecordManagement/Default" render={props=>(<RecordManagementBody {...props} userID={this.props.userID} getCurrentModule={this.getCurrentModule}/>)} />
                <Route path="/StaticPageManagement/Default" render={props=>(<StaticPageManagementBody {...props} userID={this.props.userID} getCurrentModule={this.getCurrentModule}/>)} />
                <Route path="/QAManagement/Default" render={props=>(<QAManagementBody {...props} userID={this.props.userID} getCurrentModule={this.getCurrentModule}/>)} />
                <Route path="/TrafficManagement/Default" render={props=>(<TrafficManagementBody {...props} userID={this.props.userID} getCurrentModule={this.getCurrentModule}/>)} />
                <Route path="/EventManagement/EventEditMode/:Mode/Event_SysID/:Event_SysID" render={props=>(<EventCreateBody {...props} userID={this.props.userID}/>)} />
                <Route path="/StaticPageManagement/StaticPageID/:StaticPage_SysID" render={props=>(<StaticPageCreateBody {...props} userID={this.props.userID}/>)} />            
              </Switch>
            </div>
            {this.state.toggleScreenshotPicker? <ScreenshotContainer closeScreenshotPicker={this.closeScreenshotPicker} getSreenshotArea={this.getSreenshotArea}/>:null}
            </BrowserRouter>
        )
    }
}

export default withStyles(wStyles)(MainBodyTest)

  